// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_RouteAsURL from "../Restaumatic.RouteAsURL/index.js";
import * as Unscramble from "../Unscramble/index.js";
var RestaurantId = function (x) {
    return x;
};
var udecodeRestaurantId = Unscramble.decodeInt1;
var ufromJSONKeyRestaumaticId = {
    fromJSONKey: /* #__PURE__ */ Unscramble.defaultFromJSONKeyValue(udecodeRestaurantId)
};
var showRestaurantId = Data_Show.showInt;
var ordRestaurantId = Data_Ord.ordInt;
var newtypeRestaurantId = {
    Coercible0: function () {
        return undefined;
    }
};
var eqRestaurantId = Data_Eq.eqInt;
var encodeRestaurantId = Foreign_Generic_Class.intEncode;
var decodeRestaurantId = Foreign_Generic_Class.intDecode;
var asParamRestaurantId = Restaumatic_RouteAsURL.asParamInt;
var asJSONKeyRestaumaticId = /* #__PURE__ */ (function () {
    return {
        asJSONKey: new Data_Map_Serialized.AsJSONKeyValue(Foreign_Generic_Class.encode(encodeRestaurantId), Foreign_Generic_Class.decode(decodeRestaurantId))
    };
})();
export {
    RestaurantId,
    newtypeRestaurantId,
    showRestaurantId,
    eqRestaurantId,
    ordRestaurantId,
    encodeRestaurantId,
    decodeRestaurantId,
    udecodeRestaurantId,
    asParamRestaurantId,
    asJSONKeyRestaumaticId,
    ufromJSONKeyRestaumaticId
};
//# sourceMappingURL=index.js.map
